import angular from 'angular';

import Component from './events.component';

import ComponentsModule from './components/components';

const Module = angular.module('control-room.events', [ComponentsModule.name]).component('crEvents', Component);

export default Module;
